import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";

/** Complete a password reset with the emailed token + a new password. */
export function useResetPassword() {
  return useMutation<void, ApiError, { token: string; newPassword: string }>({
    mutationFn: async (input) => {
      await apiFetch<{ ok: true }>("/auth/reset-password", {
        method: "POST",
        body: input,
      });
    },
  });
}
